<template>
  <div class="videoTipBox">
    <img src="../views/img/videoTip1.png" alt="">
    <div>新手视频演示，图片编辑一分钟学会，累计{{docnum}}人已观看--------- <span @click="closeTipBox()">关闭提醒</span></div>
  </div>
</template>

<script type="text/ecmascript-6">


export default {

  props: [

  ],
  data(){
    return {
      docnum:0,
      total_num:0,
    }
  },
  computed: {
    videoTipBoxShow() {
      return this.$store.state.videoTipBoxShow
    },
  },
  created() {
    this.totalDongHua()
  },
  methods: {
    closeTipBox(){
      this.$store.commit('setVideoTipBoxShow','false')
      localStorage.setItem('videoTipBoxShow','false');
    },
    totalDongHua(){
        let today_doc_num = 364873

        let step = parseInt(today_doc_num/20);
        let timer = setInterval(()=>{
          this.docnum = this.docnum + step;
          if(this.docnum > today_doc_num){
            this.docnum = today_doc_num;
            clearInterval(timer);
          }
        },100)

    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.videoTipBox{
  display: flex;
  align-items: flex-end;
  position: absolute;
  right: -552px;
  bottom: 106px;
  width: 550px;
  img{
    width: 50px;
    margin-right: 10px;
  }
  div{
    font-size: 14px;
    color: #fff;
    display: inline-block;
    span{
      color: #a6ff1b;
      cursor: pointer;
    }
  }
}
</style>